import React, { useState } from "react";
import whatdoimg from "../../assets/images/whychoose.png";
import FranchiseModel from "./franchiseModel";

const DesriptionSection = ({ franchiseData }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);

    return (
        <>
            <div className="whatdoSection">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="whatdoSectionInfo">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: franchiseData
                                    }}
                                />
                                <div className="text-center pb-3">
                                    <button className="moreBtn active btn-red-to-black-color-move rounded-4 mt-3 px-4 py-2"
                                        title="Enquire Now"
                                        style={{ backgroundColor: "white", color: "rgb(218, 33, 43)" }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShow(true)
                                        }} >
                                        <span> Enquire Now </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <FranchiseModel show={show} handleClose={handleClose} />
        </>
    );
};

export default DesriptionSection;
